import React from "react";

import Map from "../../assets/svg/Map";

import styles from "./SloganSection.module.scss";

const SloganSection = ({ title }) => {
  return (
    <div className={styles.SloganSection}>
      <div
        className="wrap holder no-pdn-top"
      >
        <section className={styles.Section}>
          <div className={styles.Title}>{title}</div>

          <div className={styles.MapWrapper}>
            <Map className={styles.Map} />
          </div>
        </section>
      </div>
    </div>
  );
};

export default SloganSection;
